﻿'use strict';

/**
* Factory for handling authentication and items around authenticationUI
* @memberOf components.authenticationModule
* @namespace authenticationUIFactory
*/

function authenticationUIFactory() {

    //standard authentication factory link object
    function AuthLink(passedLink, passedName) {
        this.link = passedLink;
        this.title = passedName;
    }

    /**
    * Get user log out link
    * @method getLogOutLink
    * @param {String} passedUserLogOutLinkName text for the link
    * @returns {object} log out link object
    * @memberOf components.authenticationModule.authenticationUIFactory
    */
    function getLogOutLink(passedUserLogOutLinkName) {

        return new AuthLink('authentication.logout', passedUserLogOutLinkName);
    };

    /**
    * Get user log in link
    * @method getLogInLink
    * @param {String} passedUserLogInLinkName text for the link
    * @returns {object} log out link object
    * @memberOf components.authenticationModule.authenticationUIFactory
    */
    function getLogInLink(passedUserLogInLinkName) {

        return new AuthLink('authentication.login', passedUserLogInLinkName);
    };

    var service = {
        getLogOutLink: getLogOutLink,
        getLogInLink: getLogInLink
    };

    return service;
}

module.exports = authenticationUIFactory;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/authentication/authenticationUIFactory.js
// module id = 19
// module chunks = 0